import { useContext } from "react"
import { GlobalContext } from './_app'

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'
import { HeaderShim } from '../fuselage/global/header/header'

export default function Page () {

    const globals = useContext(GlobalContext)

    return (
        <>


            <div style={{ position: `relative`, width: `100%`, height: `100vh` }}>
                <iframe
                    title="AviaDev26 onsite guide"
                    allow="clipboard-write; autoplay; encrypted-media; fullscreen; picture-in-picture"
                    sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms" allowFullScreen={true}
                    style={{ position: `absolute`, border: `none`, width: `100%`, height: `100%`, left: 0, right: 0, top: 0, bottom: 0 }}
                    src="https://e.issuu.com/embed.html?d=aviadev26_onsite_guide&u=aviadev"></iframe>
            </div>
        </>
    )
}
Page.theme = 'aviadev-2024'
